package org.example.zone360.utils

object APIEndPoints {

    private val baseUrl: String = when (currentEnv) {
        Environment.PRODUCTION -> "https://api.zone360.info"
        else -> "http://192.168.1.16:8080"
    }

    object Name {
        val login = "$baseUrl/login"
        val forget_Password = "$baseUrl/auth/forgot-password"
        val changePassword = "$baseUrl/change_password"
        val changeEmail = "$baseUrl/change_user_email"
        val create_club_admin = "$baseUrl/create_club_admin"
        val create_club_director = "$baseUrl/create_club_director"
        val get_Club_session = "$baseUrl/get_club_sessions"
        val get_Club_Keyword = "$baseUrl/get_club_keywords"
        val get_Club_Coaches = "$baseUrl/get_club_coach_aggregate"
        val get_Session_Summary = "$baseUrl/get_sessions_summary"
        val get_Player_Aggregate = "$baseUrl/get_club_player_aggregate"
        val send_Email = "$baseUrl/send-email"
        val create_player = "$baseUrl/create_club_player"
        val club_performance = "$baseUrl/get_club_performance"
        val create_Coach = "$baseUrl/create_club_coach"
        val get_Sessions = "$baseUrl/get_sessions"
        val get_Sentences = "$baseUrl/get_sentences"
        val get_Club_Players = "$baseUrl/get_club_players"
        val get_Club_Coaches_List = "$baseUrl/get_club_coaches"
        val tag_Player = "$baseUrl/tag_players"
        val tag_User = "$baseUrl/tag_users"
        val update_UserData = "$baseUrl/update_user_data"
        val get_profile = "$baseUrl/get_profile"
        val getSingleCoach = "$baseUrl/get_club_coach_aggregate_single"
        val chatbot = "$baseUrl/playerbot"
        val coachChatbot = "$baseUrl/new_chat_bot"
        val playerChatbot = "$baseUrl/new_chat_bot_player"
        val adminBotRequest = "$baseUrl/chat_admin"
        val chatAdminStream = "$baseUrl/chat_admin_stream"
        val getSinglePlayer = "$baseUrl/get_club_player_aggregate_single"
        val getClubPlayerAssessment = "$baseUrl/get_club_player_assessment_aggregate"
        val requestAssessment = "$baseUrl/request_assessment"
        val getPlayerAssessments = "$baseUrl/get_player_assessments"
        val getTagPlayerSentences = "$baseUrl/get_tag_player_sentences"
        val get_All_Teams = "$baseUrl/get_all_teams_club"
        val create_Club_Team = "$baseUrl/create_club_team"
        val delete_Club_Team = "$baseUrl/delete_club_team"
        val update_User_With_Team = "$baseUrl/update_user_with_team"
        val assessment_Rating = "$baseUrl/assessment_rating"
        val upload_Image = "$baseUrl/upload_image"
        val upload_club_Image = "$baseUrl/upload_club_image"
        val add_Custom_Highlight = "$baseUrl/add_custom_highlight"
        val edit_Summary = "$baseUrl/analyze"
        val update_Transcript = "$baseUrl/update_transcript"
        val get_session_keywords = "$baseUrl/get_keywords_by_id"
        val update_org = "$baseUrl/update_org"
        val create_checkout = "$baseUrl/create-checkout-session"
        val create_subscription = "$baseUrl/create-subscription-checkout-session"
        val cancel_subscription = "$baseUrl/cancel-subscription"
        val create_checkout_addon = "$baseUrl/create-checkout-addon"
        val commit_chunks = "$baseUrl/commit-chunks"
        val upload_chunks = "$baseUrl/upload-chunk"
        val add_video_session = "$baseUrl/add_video_session"
        val bulk_create_club_player = "$baseUrl/bulk_create_club_players_simple"
        val bulk_create_club_coach = "$baseUrl/bulk_create_club_coaches"
        val delete_session = "$baseUrl/archive_session"
        val analysis_refresh = "$baseUrl/analyze"
        val create_keywords = "$baseUrl/create_keywords"
        val custom_keywords = "$baseUrl/get_custom_keywords"
        val delete_keyword = "$baseUrl/delete_keyword?"
        val request_assessment = "$baseUrl/request_session"
        val get_notification = "$baseUrl/get_notification"
        val update_notification = "$baseUrl/notification/read_all"
        val bulk_team_assessment = "$baseUrl/request_assessment_bulk"
        val existing_assessment = "$baseUrl/existing_assessment "
        val disable_coach = "$baseUrl/disable_user"
        val save_club_season = "$baseUrl/save_club_season"
        val get_club_season = "$baseUrl/get_club_seasons"
        val delete_club_season = "$baseUrl/delete_club_season"
        val remove_user_season = "$baseUrl/remove_user_season"
        val summarize_player_assessment = "$baseUrl/summarize_player_assessments"
        val upload_audio_chunks_new = "$baseUrl/upload_audio_chunks_new"
        val get_custom_names = "$baseUrl/get_custom_names"
        val create_names = "$baseUrl/create_names"
        val delete_names = "$baseUrl/delete_name?"
        val get_club_names = "$baseUrl/get_club_names"
        val get_names_by_id = "$baseUrl/get_names_by_id"
        val generate_chatbot_report = "$baseUrl/generate_chatbot_report"
        val get_club_widget_overview = "$baseUrl/get_club_widget_overview"
        val single_club_widget = "$baseUrl/get_widget_detail"
        val save_widgets = "$baseUrl/save_widget_config"
        val get_club_widget_data = "$baseUrl/get_widget_config"
        val get_widget_detail = "$baseUrl/get_widget_detail"
        val get_widget_coach_profile = "$baseUrl/get_coach_widget_overview"
        val coach_chatbot_stream = "$baseUrl/coach_bot_stream"
        val player_chatbot_stream = "$baseUrl/player_bot_stream"

    }
}


